import { render, staticRenderFns } from "./FacturaDetalle.vue?vue&type=template&id=4b241f14"
import script from "./FacturaDetalle.vue?vue&type=script&lang=js"
export * from "./FacturaDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports